<template>
  <div class="app-container">
    <el-row>
      <el-col :span="5">
        <el-scrollbar wrapClass="scrollbar-wrapper">
          <el-menu mode="vertical" :show-timeout="200" default-active="1" background-color="#fff" text-color="#000"
            @select="handleSelect" active-text-color="#409EFF">
            <help-item v-for="item in items" @add="add" @edits="edits" @deletes="deletes" :key="item.name" :item="item">
            </help-item>
          </el-menu>
        </el-scrollbar>
      </el-col>
      <el-col :span="19" style="padding-left: 20px;box-sizing: border-box;">
        <div class="filter-container">
          <el-input clearable style="width: 200px;" class="filter-item" placeholder="请输入活动名称" v-model="listQuery.key">
          </el-input>
          <el-button class="filter-item" type="info" icon="el-icon-search" @click="doSearch">搜索</el-button>
          <el-button class="filter-item" icon="el-icon-refresh" @click="doReset">重置</el-button>
          <el-button class="filter-item" icon="el-icon-plus" @click="addArticle">添加内容</el-button>
        </div>
        <el-table :data="list" v-loading="listLoading" fit border highlight-current-row style="width: 100%;"  max-height="550">
          <el-table-column align="left" label="内容编号" width="200">
            <template slot-scope="scope">
              <span>{{ scope.row.code }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="内容标题" min-width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.title }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="排序" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.sort }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="更新时间" width="165">
            <template slot-scope="scope">
              <span>{{ scope.row.updatedAt | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="230" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" v-if="!scope.row.isPublish" @click="Publish(scope.row)">发布</el-button>
              <el-button size="mini" @click="edit(scope.row)">编辑</el-button>
              <el-button size="mini" @click="Delete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-container">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
            layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog title="新增二级" :visible.sync="addVisible" width="30%">
      <el-form ref="addForm" :model="addForm" label-position="right" label-width="120px">
        <el-form-item label="名称">
          <el-input clearable style="width: 200px;" class="filter-item" placeholder="请输入二级名称" v-model="addForm.name">
          </el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input clearable style="width: 200px;" class="filter-item" placeholder="请输入排序" v-model="addForm.sort">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addVisible = false">取消</el-button>
        <el-button type="primary" @click="addConfim">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="编辑二级" :visible.sync="editVisible" width="30%">
      <el-form ref="editForm" :model="editForm" label-position="right" label-width="120px">
        <el-form-item label="名称">
          <el-input clearable style="width: 200px;" class="filter-item" placeholder="请输入二级名称" v-model="editForm.name">
          </el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input clearable style="width: 200px;" class="filter-item" placeholder="请输入排序" v-model="editForm.sort">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editVisible = false">取消</el-button>
        <el-button type="primary" @click="editConfim">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import HelpItem from "./item";
export default {
  name: "bydHelp",
  components: { HelpItem },
  data() {
    return {
      items: [],
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        key: ""
      },
      nodeId: "",
      addForm: {
        fatherId: "",
        name: "",
        sort: ""
      },
      addVisible: false,
      editForm: {
        name: "",
        sort: "",
        nodeId: ""
      },
      editVisible: false
    };
  },
  created() {
    this.getItems();
  },
  activated() {
    this.doReset();
  },
  mounted() {},
  methods: {
    getItems() {
      this.$httpAuth
        .post("/v1/backendHelpRpc/categories", { businessType: 1 })
        .then(res => {
          this.items = [...res.data.data.sort(this.compare("sort", true))];
          if (this.items[0].childs.length === 0) {
            this.handleSelect(1);
          }
        });
    },
    doReset() {
      if (this.nodeId === "") {
        return;
      }
      this.list = null;
      this.total = 0;
      this.listLoading = true;
      this.listQuery = {
        page: 1,
        limit: 10,
        key: ""
      };
      this.doSearch();
    },
    doSearch() {
      this.listQuery.page = 1;
      this.getList();
    },
    getList() {
      this.listLoading = true;
      this.$httpAuth
        .post("/v1/backendHelpRpc/articles", {
          key: this.listQuery.key,
          pageStart: (this.listQuery.page - 1) * this.listQuery.limit,
          pageCount: this.listQuery.limit,
          nodeId: this.nodeId
        })
        .then(res => {
          this.listLoading = false;
          this.list = res.data.data;
          this.total = res.data.total;
        })
        .catch(() => {
          this.listLoading = false;
        });
    },
    add(id) {
      this.addForm = {
        fatherId: id,
        name: "",
        sort: ""
      };
      this.addVisible = true;
    },
    addConfim() {
      this.$httpAuth
        .post("/v1/backendHelpRpc/addSubCategory", {
          fatherId: this.addForm.fatherId,
          name: this.addForm.name,
          sort: Number(this.addForm.sort),
          businessType: 1
        })
        .then(res => {
          this.getItems();
          this.$notify({
            title: "提示",
            message: "保存成功"
          });
          this.addVisible = false;
        });
    },
    edits(item) {
      console.log(1);
      var item = JSON.parse(item);
      this.editForm = {
        name: item.name,
        sort: item.sort,
        nodeId: item.id
      };
      this.editVisible = true;
    },
    deletes(id) {
      this.$confirm("是否删除该二级分类?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          var that = this;
          this.$httpAuth
            .post("/v1/backendHelpRpc/deleteSubCategory", {
              nodeId: id
            })
            .then(res => {
              that.getItems();
              that.$notify({
                title: "提示",
                message: "删除成功"
              });
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    editConfim() {
      this.$httpAuth
        .post("/v1/backendHelpRpc/updateSubCategory", {
          nodeId: this.editForm.nodeId,
          name: this.editForm.name,
          sort: Number(this.editForm.sort),
          businessType: 1
        })
        .then(res => {
          this.getItems();
          this.$notify({
            title: "提示",
            message: "保存成功"
          });
          this.editVisible = false;
        });
    },
    // property：属性名，desc：true(升序) false(降序)
    compare(property, desc) {
      return function(a, b) {
        var value1 = a[property];
        var value2 = b[property];
        if (desc == true) {
          return value1 - value2;
        } else {
          return value2 - value1;
        }
      };
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelect(key) {
      this.nodeId = Number(key);
      this.doReset();
    },
    addArticle() {
      this.$router.push({
        path: "/help/bydArticle?" + new Date().getTime(),
        query: { nodeId: this.nodeId }
      });
    },
    Publish(row) {
      this.$confirm("是否发布该文章?", "提示", {
        confirmButtonText: "发布",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        var parent = this;
        this.$httpAuth
          .post("/v1/backendHelpRpc/updateArticle", {
            articleId: row.id,
            title: row.title,
            content: row.content,
            code: row.code,
            isPublish: true,
            sort: row.sort
          })
          .then(function(response) {
            parent.$message({
              message: "发布成功",
              type: "success"
            });
            parent.getList();
          });
      });
    },
    edit(row) {
      this.$router.push({
        path: "/help/bydArticle",
        query: { articleId: row.id }
      });
    },
    Delete(row) {
      this.$confirm("是否删除该文章?", "提示", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        var parent = this;
        this.$httpAuth
          .post("/v1/backendHelpRpc/deleteArticle", {
            articleId: row.id
          })
          .then(function(response) {
            parent.$message({
              message: "删除成功",
              type: "success"
            });
            parent.getList();
          });
      });
    }
  }
};
</script>
<style scoped>
.filter-container {
}
</style>
